const INITIAL_STATE = {
  rfidScans: [],
  selected: -1
};

export const collectiveRegisterRFIDReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CLEAR_COLLECTIVE_REGISTER_RFID_PAGE': {
      return INITIAL_STATE;
    }
    case 'COLLECTIVE_UPDATE_REGISTER_RFID_SCANS':
      return {
        ...state,
        rfidScans: action.payload
      };
    case 'UPDATE_COLLECTIVE_REGISTER_RFID_SELECTED':
      return {
        ...state,
        selected: action.payload
      };
    default:
      return state;
  }
};
